import { Typography, Box } from '@mui/material'
import theme from 'lib/theme'
import { formatPrice } from 'lib/utils'
import { PickingStatus, Product } from 'types/model/product'

export const ChargedColumn = ({ product }: { product: Product }) => {
  if (
    !product.collectedProduct ||
    Object.keys(product.collectedProduct)?.length === 0
  ) {
    return (
      <Box p={1} height={theme.spacing(9)}>
        <Typography variant='body2'>–</Typography>
      </Box>
    )
  }

  const collectedProductPrice = product.collectedProduct.capturedPrice?.priceVat
  const substituted = product.pickingStatus === PickingStatus.SUBSTITUTED
  return (
    <>
      {substituted && (
        <Box
          sx={{
            height: theme.spacing(9),
          }}
          p={1}>
          {collectedProductPrice && (
            <Typography variant='body2'>
              {formatPrice(collectedProductPrice)}
            </Typography>
          )}
        </Box>
      )}
      <Box sx={{ height: theme.spacing(9) }} p={1}>
        {substituted ? (
          <Typography variant='body2'>–</Typography>
        ) : (
          <Typography variant='body2'>
            {formatPrice(collectedProductPrice) ?? '–'}
          </Typography>
        )}
      </Box>
    </>
  )
}
